<template>
    <div>
        <!-- Modal confirm delete -->
        <modal height="auto" :scrollable="true" name="modal-confirm-delete" :adaptive="true">
            <div class="p-12">
                <h3 class="font-bold text-xl">{{$t('user.products.requests.confirmation')}}</h3>
                <p class="font-light text-sm mt-2">{{$t('user.products.requests.etes_vous_sur_de_vouloir_supprimer_cette_demande_de_sav_?')}}</p>
                <div class="w-full mt-3">
                    <button @click="$modal.hide('modal-confirm-delete')" class="bg-gray-200 hover:bg-gray-300 duration-100 px-3 py-2 text-sm font-light border-gray-200 rounded-xl">
                        <small>
                            <i class="fas fa-times mr-1"></i>{{$t('user.products.requests.annuler')}}
                        </small>
                    </button>
                    <button class="text-red-900 bg-red-300 hover:bg-red-400 duration-100 px-3 py-2 text-sm font-light border-red-200 rounded-xl" @click="deleteRequest(selectedItem.id)">
                        <i class="fas fa-check mr-1"></i> {{$t('user.products.requests.confirmer')}}
                    </button>
                </div>
            </div>
        </modal>
        <!-- Modal confirm discard -->
        <modal height="auto" :scrollable="true" :adaptive="true" name="modal-confirm-discard-form">
            <div class="p-12">
                <h3 class="font-bold text-xl">{{$t('user.products.requests.attention')}}</h3>
                <p class="font-light text-sm mt-2">{{$t('user.products.requests.en_continuer_ce_dossier_vous_allez_ecraser_votre_formulaire_en_cours')}}</p>
                <div class="w-full mt-3">
                    <button @click="$modal.hide('modal-confirm-discard-form')" class="bg-gray-200 hover:bg-gray-300 duration-100 px-3 py-2 text-sm font-light border-gray-200 rounded-xl">
                        <small>
                            <i class="fas fa-times mr-1"></i>{{$t('user.product.list.modal_delete_2')}}
                        </small>
                    </button>
                    <button class="text-orange-900 bg-orange-300 hover:bg-orange-400 duration-100 px-3 py-2 text-sm font-light border-red-200 rounded-xl" @click="continueForm">
                        <i class="fas fa-check mr-1"></i> {{$t('user.products.requests.confirmer')}}
                    </button>
                </div>
            </div>
        </modal>
        <sav-template title="Mes demandes en cours">
            <sav-spinner more-class="mb-3" v-show="loading" />
            <div v-if="requests.length <= 0 && !loading" class="shadow p-6 my-4 my-rounded bg-white border border-gray-200"> {{$t('user.products.requests.aucune_demande_en_cours')}}
            </div>
            <div v-for="item in requests" :key="item.id" class="mb-3">
                <sav-fold-card :id="item.id" :title="item.isOpen ? item.modele : null" v-model="item.isOpen" :state="item.etat">
                    <template v-slot:close>
                        <b>{{item.modele}}</b>
                        <div class="mb-1">
                            <small>{{$t('user.products.requests.ean')}}: {{item.ean}}</small>
                        </div>
                        <badge-state :state="item.etat" :label="item.commentaire" />
                    </template>
                    <template v-slot:open>
                        <div class="mt-4">
                            <template v-if="item.date_demande">
                                <hr class="my-3">
                                <h6 class="font-bold mb-1">{{$t('user.products.requests.date_demande')}}</h6>
                                <span class="text-gray-600 mb-2 block"> {{ transformDate(item.date_demande) }} </span>
                            </template>
                            <hr class="my-3">
                            <h6 class="font-bold mb-1">{{$t('user.products.requests.date_d_achat')}}</h6>
                            <span class="text-gray-600 mb-2 block"> {{ transformDate(item.date_achat) }} </span>
                            <hr class="my-3">
                            <h6 class="font-bold mb-1">{{$t('user.products.requests.ean')}}</h6>
                            <span class="text-gray-600 mb-2 block"> {{ item.ean }} </span>
                            <template v-if="item.commentaire">
                                <hr class="my-3">
                                <h6 class="font-bold mb-1">{{$t('user.products.requests.commentaire')}}</h6>
                                <span class="text-gray-600 mb-2 block"> {{ item.commentaire }} </span>
                            </template>
                            <template v-if="item.ticketPicture">
                                <hr class="my-3">
                                <h6 class="font-bold mb-1">{{$t('user.products.requests.justificatif_d_achat')}}</h6>
                                <a class="text-blue-500 hover:underline text-xs" target="_blank" :href="item.ticketPicture.url">
                                    <i class="fas fa-link mr-1"></i> {{$t('user.products.requests.consulter_le_fichier')}}
                                </a>
                            </template>
                            <template v-if="item.nameplatePicture">
                                <hr class="my-3">
                                <h6 class="font-bold mb-1">{{$t('user.products.requests.plaque_signaletique')}}</h6>
                                <a class="text-blue-500 hover:underline text-xs" target="_blank" :href="item.nameplatePicture.url">
                                    <i class="fas fa-link mr-1"></i> {{$t('user.products.requests.consulter_le_fichier')}}
                                </a>
                            </template>
                            <hr class="my-3">
                            <div class="flex flex-wrap ">
                                <div class="w-1/2 text-right" v-if="item.form">
                                    <button v-if="item.etat == 1" @click="editRequest(item)" class="text-gray-900 bg-gray-300 hover:bg-gray-400 duration-200 px-3 py-2 text-sm font-light border-red-200 rounded-xl mr-1">
                                        <i class="fas fa-edit mr-1"></i>{{$t('user.products.requests.continuer_la_procedure')}}
                                    </button>
                                    <button v-else @click="editRequest(item)" class="text-gray-900 bg-gray-300 hover:bg-gray-400 duration-200 px-3 py-2 text-sm font-light border-red-200 rounded-xl mr-1">
                                        <i class="fas fa-edit mr-1"></i>{{$t('user.products.requests.modifier')}}
                                    </button>
                                </div>
                                <div class="w-1/2">
                                    <button @click="displayConfirmDeleteModal(item)" class="text-red-900 bg-red-300 hover:bg-red-400 duration-200 px-3 py-2 text-sm font-light border-red-200 rounded-xl ml-1">
                                        <i class="fas fa-trash-alt mr-1"></i>{{$t('user.products.requests.supprimer')}}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </template>
                </sav-fold-card>
            </div>
        </sav-template>
    </div>
</template>

<script>
import eventHub from '@/eventHub'

import apiService from '@/services/api.service'

import SavForm from '../../../../../components/SavForm.vue'
import BadgeState from '@/companies/default/views/user/product/BadgeState.vue'

import moment from 'moment'

export default {
  components: { SavForm, BadgeState },
    data() {
        return {
            client_id: null,
            loading: false,
            requests: [],
            selectedUpdateRequest: null,
            selectedItem: null,
        }
    },

    methods: {
        transformDate(date) {
            return moment(date).lang("fr").format('LL');
        },

        async getSavRequests() {
            this.loading = true
            let response = await apiService.post('getrequestapp', {
                id_conso: this.client_id
            })
            this.requests = response.data.posts.post.reverse()
            this.requests = this.requests.map(item => ({...item, update: false}))
            this.getFiles()
            this.loading = false
        },

        getFiles() {
            this.requests.forEach((item, index) => {
                if (item.id_justif) {
                    this.getFile(index, item.id_justif, 'ticketPicture')
                }
                if (item.id_plaque) {
                    this.getFile(index, item.id_plaque, 'nameplatePicture')
                }
            })
        },

        async getFile(index, id, name) {
            await apiService.post('getfile', {
                id_conso: this.client_id,
                id_file: id
            }).then((response) => {
                this.requests[index][name] = response.data.posts.post
            })
        },

        editRequest(item) {
            this.selectedItem = item
            if (localStorage['form-data']) {
                this.$modal.show('modal-confirm-discard-form')
            } else {
                this.continueForm()
            }
        },

        continueForm() {
            if (this.selectedItem) {
                localStorage.removeItem('form-data')
                localStorage.setItem('form-data', this.selectedItem.form)
                this.$formTool.addFormData('request-case', this.selectedItem)
                this.$router.push({name: 'form.home'})
            }
        },

        displayConfirmDeleteModal(item) {
            this.selectedItem = item
            this.$modal.show('modal-confirm-delete')
        },

        async deleteRequest(itemId) {
            await apiService.post('deleterequest', {
                id_case: itemId
            }).then(() => {
                this.selectedItem = null
                this.getSavRequests()
                this.$modal.hide('modal-confirm-delete')
            })
        },
        
        closeAllCard(cardIdNotClose) {
            this.requests.forEach((item) => {
                if (item.id != cardIdNotClose) {
                    item.isOpen = false
                }
            })
        }
    },

    mounted() {
        this.client_id = this.$crypto.decrypt(localStorage.getItem('client_id'))
        this.getSavRequests()

        eventHub.$on('card-open-close', (cardInfo) => {
            if (cardInfo.value === true && cardInfo.itemId) {
                this.closeAllCard(cardInfo.itemId)
            }
        })
    },
}
</script>



// WEBPACK FOOTER //
// src/companies/casino/views/user/products/Requests.vue